import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Chip, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useSearchableMenu } from 'shared/domains/common-ui/SearchableMenu';
export function NewValue(props) {
    const { addItem } = props;
    const { searchString, resetSearch, searching, items } = useSearchableMenu();
    const handleAdd = () => {
        addItem(searchString);
        resetSearch();
    };
    const exactMatch = items.find((item) => item.id.toLowerCase().trim() === searchString.toLowerCase().trim());
    if (!searchString || !searching || exactMatch) {
        return null;
    }
    return (<Fragment>
      <Menu.Label>
        <Trans comment="Metadata: New value header">New</Trans>
      </Menu.Label>
      <Menu.Item onClick={handleAdd}>
        <Menu.ItemText truncate primary={searchString}/>

        <Box ml="auto" pl="3xl">
          <Chip label={t({ message: 'Add', comment: 'Metadata: Add new value' })} appearance="info" icon={<Falcon icon="add"/>}/>
        </Box>
      </Menu.Item>
    </Fragment>);
}
